import { motion } from "framer-motion";

const PromoBanner = () => {
  return (
    <section className="bg-[#d6a89e] py-16 px-4 text-white">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto text-center"
      >
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4">
          A Gift from SuprSkin ✨
        </h2>
        <p className="mb-6 text-lg opacity-90">
          Use promo code <span className="font-bold text-[#fef8f5] bg-[#7a6e5f] px-2 py-1 rounded-md">LOVEYOURSELF</span> at checkout
          and get 15% off your first personalised routine.
        </p>
        <p className="text-sm opacity-80">
          Valid on all products — because your skin deserves a little extra love.
        </p>
      </motion.div>
    </section>
  );
};

export default PromoBanner;
